import { Box } from "@mui/material";

export default function AuthProgressBar({ step = 1 }) {
  const isStep1Filled = step >= 1;
  const isStep2Filled = step >= 2;

  return (
    <Box sx={{ display: "flex", gap: 1.25, width: "100%", py: 1 }}>
      <Box
        sx={{
          height: 8,
          borderRadius: "9px",
          flex: 1,
          backgroundColor: isStep1Filled ? "#ee4d37" : "#fce2dd",
          border: isStep1Filled ? "1px solid #ee4d37" : "none",
        }}
      />
      <Box
        sx={{
          height: 8,
          borderRadius: "9px",
          flex: 1,
          backgroundColor: isStep2Filled ? "#ee4d37" : "#fce2dd",
          border: isStep2Filled ? "1px solid #ee4d37" : "none",
        }}
      />
    </Box>
  );
}
